// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3-WLl","header":"PatientQuestionnaire_header__SHLX-","info":"PatientQuestionnaire_info__HZ7xq"};